import React from "react";
import AdminEntityList from "@/components/admin/AdminEntityList";

const fields = [
  { key: "name", label: "Name", required: true },
  { key: "slug", label: "Slug (auto if empty)" },
  { key: "description", label: "Description", type: "textarea", rows: 4 },
  { key: "common_challenges", label: "Common challenges", type: "list" },
  { key: "hero_image", label: "Hero image URL" },
];

export default function AdminIndustries() {
  return <AdminEntityList title="Industries" endpoint="/admin/industries" listEndpoint="/industries" fields={fields} testIdBase="admin-industries" />;
}
